export const version = '2.3.2'
